const vpc_lib = {
  string: (v) => Boolean(v.length),
}

export default {
  bind: function (arg, binding, vNode) {
    const config = __validate_driective_build_config(arg, binding, vNode)
    const {
      child,
      parent,
      main_key,
      is_required,
      event_name,
      validation_function,
      value_presence_check_type,
    } = config

    __validate_directive_print_warnings(config)

    child.__is_inline = true
    child._data.PRIVATE_VALIDITY = parent?.validity[main_key] ?? false
    parent.$watch(`validity.${main_key}`, function () {
      child._data.PRIVATE_VALIDITY = parent?.validity[main_key] ?? false
      child.__is_inline = false
    })
    child.$on(event_name, async function () {
      child.__is_inline = true
      await __set_validation_status(config)
    })
    parent.$on(`validating_${main_key}`, async function () {
      await __set_validation_status(config, true)
    })
    parent.$on(`force_error_${main_key}`, function () {
      parent.validity[main_key] = false
      if (typeof child.scrollToSelf === "function") child.scrollToSelf()
    })
    child.$watch("value", function () {
      parent.validity[main_key] = true
    })
  },
}

async function __set_validation_status(
  {
    main_key,
    child,
    parent,
    validation_function,
    value_presence_check_type,
    is_required,
  },
  force
) {
  if (force || is_required || vpc_lib[value_presence_check_type](child.value)) {
    child._data.PRIVATE_IS_VALIDATING = true
    parent.validity[main_key] = await validation_function(child.value)
    parent.$nextTick(() => {
      child._data.PRIVATE_IS_VALIDATING = false
    })
  } else child._data.PRIVATE_IS_VALIDATING = false
  if (__check_if_focus_is_needed({ parent, main_key }) && !child.__is_inline) {
    if (typeof child.scrollToSelf === "function") child.scrollToSelf()
  }
}

function __check_if_focus_is_needed({ parent, main_key }) {
  const validity_object = parent.validity ?? {}

  for (let key in validity_object) {
    if (!validity_object[key]) return key === main_key
  }
  return false
}

function __validate_driective_build_config(arg, binding, vNode) {
  const main_key = binding.arg

  return {
    child: vNode.componentInstance,
    parent: vNode.context,
    is_required: binding.modifiers.required ?? false,
    event_name: binding.value?.event_name ?? "blur",
    value_presence_check_type: binding.value?.vpct ?? "string",
    validation_function: vNode.context[`validate_${main_key}`],
    main_key,
  }
}

function __validate_directive_print_warnings({
  main_key,
  child,
  validation_function,
  parent,
  value_presence_check_type,
}) {
  if (typeof main_key !== "string")
    console.warn(
      "[Validate Directive] No main_key was passed (v-validate:main_key)"
    )
  if (typeof child._data.PRIVATE_VALIDITY !== "boolean")
    console.warn(
      "[Validate Directive] child as no PRIVATE_VALIDITY value pre-defined"
    )
  if (typeof validation_function !== "function")
    console.warn(
      `[Validate Directive] No validation function was found for ${main_key}`
    )
  if (typeof parent.validity !== "object")
    console.warn(
      `[Validate Directive] No validity object was found in the parent`
    )
  else if (typeof parent.validity[main_key] !== "boolean")
    console.warn(
      `[Validate Directive] No validation value was found for ${main_key} in the validity object`
    )
  if (typeof vpc_lib[value_presence_check_type] !== "function")
    console.warn(
      `[Validate Directive] No value presence check type of ${value_presence_check_type} was found in our vpc_lib`
    )
}
